import { InfoMailTipLargeAudienceIndividualText } from './LargeAudienceDetails.locstring.json';
import { ApproximateNumberCountText, InfoMailtipCustomText } from '../strings.locstring.json';
import loc, { format, formatToArray } from 'owa-localize';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

import RemoveRecipientButton from './RemoveRecipientButton';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

const styles = require('./MultiRecipientMailtip.scss');

export interface LargeAudienceDetailsProps {
    colorScheme?: ColorScheme;
    onRecipientRemoveClick: (recipient: EmailAddressWrapper) => void;
    recipientsInfo: RecipientMailtipInfoWithMembersCount[];
    approximateMemberLimit: number;
}

export interface RecipientMailtipInfoWithMembersCount {
    recipient: EmailAddressWrapper;
    totalMemberCount: number;
}

const LargeAudienceDetails = (props: LargeAudienceDetailsProps) => {
    let individualMembersCount: number = 0;

    return (
        <div>
            {props.recipientsInfo.map(recipientInfo => {
                const { totalMemberCount } = recipientInfo;
                const emailAddress: string = recipientInfo.recipient.EmailAddress;

                if (totalMemberCount > 1) {
                    const memberCountText: string =
                        totalMemberCount >= props.approximateMemberLimit
                            ? format(loc(ApproximateNumberCountText), totalMemberCount)
                            : totalMemberCount.toString();

                    return (
                        <div key={emailAddress}>
                            <span>
                                {formatToArray(
                                    loc(InfoMailtipCustomText),
                                    <span className={styles.recipientName} key={emailAddress}>
                                        {recipientInfo.recipient.Name}
                                    </span>,
                                    <span key={`${emailAddress}-groupCount`}>
                                        {memberCountText}
                                    </span>
                                )}
                            </span>
                            <RemoveRecipientButton
                                colorScheme={props.colorScheme}
                                onClick={props.onRecipientRemoveClick}
                                recipient={recipientInfo.recipient}
                            />
                        </div>
                    );
                } else {
                    individualMembersCount += totalMemberCount;
                    return null;
                }
            })}
            {!!individualMembersCount && (
                <span>
                    {format(loc(InfoMailTipLargeAudienceIndividualText), individualMembersCount)}
                </span>
            )}
        </div>
    );
};

export default LargeAudienceDetails;
